import { useCallback } from 'react';

import {
  GeneratedGetLinkedDrawEntryIntentQuery,
  useGetLinkedDrawEntryIntentLazyQuery,
} from '../../../types/generated';
import {
  EntryIntentPollingController,
  useEntryIntentPolling,
} from './useEntryIntentPolling';

export type ConfirmedLinkedDrawEntryIntent = NonNullable<
  GeneratedGetLinkedDrawEntryIntentQuery['getLinkedDrawEntryIntent']
>;

export type LinkedDrawEntryConfirmationArgs = {
  onConfirmed: (intent: ConfirmedLinkedDrawEntryIntent) => Promise<void>;
};

export type LinkedDrawEntryConfirmationController =
  EntryIntentPollingController;

export const useLinkedDrawEntryConfirmation = ({
  onConfirmed,
}: LinkedDrawEntryConfirmationArgs): LinkedDrawEntryConfirmationController => {
  const [getLinkedDrawEntryIntent] = useGetLinkedDrawEntryIntentLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const read = useCallback(
    async (intentId: string) => {
      const { data, error } = await getLinkedDrawEntryIntent({
        variables: { id: intentId },
      });

      return { error, intent: data?.getLinkedDrawEntryIntent };
    },
    [getLinkedDrawEntryIntent],
  );

  return useEntryIntentPolling({
    label: 'Linked draw entry intent',
    onConfirmed,
    read,
  });
};
